import { getByKey_Boolean, getByKey_Array } from './Utils'

// ***** NOTE *****
// Everything in this selector retrieves the instance level configuration value first
// and then if there is nothing there, it'll go grab the ORG level configuration value.

export const isFeatureOn = (state, key) => {
  const featureEnablementOnValues = getFeatureEnablement_ON(state)
  const featureEnablementOffValues = getFeatureEnablement_OFF(state)

  let isFeatureOn = false

  if (featureEnablementOnValues && featureEnablementOnValues.includes(key)) {
    isFeatureOn = true
  }

  if (featureEnablementOffValues && featureEnablementOffValues.includes(key)) {
    isFeatureOn = false
  }

  return isFeatureOn
}

export const getFeatureEnablement_ON = (state) => {
  return getByKey_Array(state, 'featureEnablement_ON', true)
}

export const getFeatureEnablement_OFF = (state) => {
  return getByKey_Array(state, 'featureEnablement_OFF', true)
}

/**
 * Retrieve if the developer_featureEnabled flag is on/off in VNConfigs
 * @param {*} state
 * @returns {Boolean} true if it is enabled, false otherwise
 */
export const getEnabledDeveloperFeature = (state) => {
  return getByKey_Boolean(state, 'developer_featureEnabled')
}

/**
 * Retrieve if the ppi_staticCredentialCompareOnly flag is on/off in VNConfigs
 * @param {*} state
 * @returns {Boolean} true if it is enabled, false otherwise
 */
export const getPpiStaticCredentialCompareOnly = (state) => {
  return getByKey_Boolean(state, 'ppi_staticCredentialCompareOnly')
}

/**
 * Retrieve if the ppi_supressErrorToastMessages flag is on/off in VNConfigs
 * @param {*} state
 * @returns {Boolean} true if it is enabled, false otherwise
 */
export const getPpiSurpressErrorToastMessages = (state) => {
  return getByKey_Boolean(state, 'ppi_supressErrorToastMessages')
}
